
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetolavasacabs() {



    const cardData =
    {
        keyword: ' Pune to Lavasa Cab',
        heading: 'Prince Cabs: Pune to Lavasa Cab',
        headingDescription: 'Prince Cabs provides convenient Pune to Lavasa Cab services, ideal for weekend getaways, family trips, corporate outings, and leisure travel. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a smooth and comfortable journey through the scenic hills leading to Lavasa. With professional chauffeurs, flexible schedules, and on-time pickups, we make your Pune to Lavasa travel hassle-free and enjoyable. Choose Prince Cabs’ trusted cab service from Pune to Lavasa for affordability, comfort, and reliable service.',

        top: 'Top Places to Visit in Lavasa with Prince Cabs',

"topPlaces": [
  {
    "title": "Lakeside Promenade",
    "description": "The Lakeside Promenade is the heart of Lavasa, offering colorful architecture, restaurants, and scenic views along the waterfront. Visitors enjoy walking, cycling, or relaxing by the lakeside benches. The promenade is lined with cafés serving international and local cuisines. It is a lively hub for photography and family outings. Sunsets over the lake create magical moments. The vibrant setup makes it the most popular spot in Lavasa."
  },
  {
    "title": "Temghar Dam",
    "description": "Temghar Dam, located near Lavasa, supplies water to the entire region and creates the stunning backwaters. The dam is especially beautiful during monsoon when the gates overflow and waterfalls form around it. Visitors enjoy scenic drives leading to the dam. The lush greenery and misty atmosphere make it a favorite among nature lovers. It also serves as a picnic spot with panoramic valley views. Temghar adds natural charm to Lavasa’s appeal."
  },
  {
    "title": "Adventure Sports (XThrill Academy)",
    "description": "Lavasa is famous for its adventure sports, and XThrill Adventure Academy offers activities like rock climbing, rappelling, ziplining, and ATV rides. Visitors also enjoy camping and trekking through the Sahyadri hills. The adrenaline-packed experiences attract youngsters and corporate groups. Safety measures and trained instructors make it a reliable destination for adventure tourism. It is perfect for thrill seekers looking to mix leisure with excitement. Adventure sports add an energetic vibe to Lavasa."
  },
  {
    "title": "Lakeside Boating",
    "description": "Boating on the calm waters of Lavasa Lake is a relaxing experience for families and couples. Options include paddle boats, motorboats, and even luxury cruises. The surrounding hills reflect beautifully in the lake, enhancing the charm. Evening boat rides with cool breezes are especially refreshing. Tourists love combining boating with lakeside dining. It is one of the most enjoyable leisure activities in Lavasa."
  },
  {
    "title": "Bamboosa Craft Factory",
    "description": "Bamboosa is a unique craft center in Lavasa showcasing eco-friendly bamboo products. Visitors can watch artisans at work and purchase handcrafted items like furniture, décor, and souvenirs. The initiative supports local craftsmanship and promotes sustainable living. Workshops are also held for tourists interested in bamboo art. The factory is both educational and cultural. It is a hidden gem for shoppers and art enthusiasts in Lavasa."
  },
  {
    "title": "Nature Trails & Hiking",
    "description": "Lavasa is surrounded by lush green hills, offering multiple trekking and hiking routes. Trails lead through forests, valleys, and waterfalls, especially lively during monsoon. Popular routes include treks to nearby viewpoints with stunning vistas. Birdwatchers often spot unique species in the region. The peaceful environment makes it ideal for meditation walks too. Nature lovers find Lavasa a refreshing escape from city life."
  },
  {
    "title": "Dasve Viewpoint",
    "description": "Dasve Viewpoint offers breathtaking views of Lavasa town, the lake, and the surrounding Sahyadris. It is a popular photography spot, especially at sunrise and sunset. The colorful buildings of Lavasa look picturesque from this vantage point. Visitors enjoy short drives or hikes to reach the point. Cool breezes and scenic landscapes create a calming experience. It is one of the must-visit viewpoints in Lavasa."
  },
  {
    "title": "Waterfall Safari",
    "description": "During monsoon, Lavasa transforms into a land of cascading waterfalls. Local operators organize waterfall safaris, where tourists can explore hidden falls in the nearby hills. Visitors enjoy bathing under natural streams and capturing scenic beauty. The experience is adventurous yet refreshing. It is a favorite among families, trekkers, and nature photographers. Waterfall safaris highlight Lavasa’s monsoon charm."
  },
  {
    "title": "Wellness Retreats & Spas",
    "description": "Lavasa is home to luxury resorts and wellness centers offering spa treatments, yoga sessions, and Ayurvedic therapies. These retreats attract couples and professionals seeking relaxation. The calm environment amidst hills adds to the rejuvenating experience. Wellness packages often include lakeside meditation and organic meals. Visitors combine leisure with health-focused activities here. Lavasa is fast becoming a hub for wellness tourism."
  },
  {
    "title": "Dining & Cafés",
    "description": "The food scene in Lavasa is lively, with lakeside cafés, fine-dining restaurants, and local eateries. Visitors enjoy everything from authentic Maharashtrian thalis to international cuisines. Popular cafés on the promenade offer open-air seating with lake views. Culinary festivals and seasonal specials add to the attraction. Food and ambiance together make dining a memorable experience. Lavasa is as much about gastronomy as it is about nature."
  }
],


"services": [
    {
        "name": "Pune to Lavasa Taxi Fare",
        "description": "Get detailed and transparent taxi fare estimates for your journey from Pune to Lavasa. Our competitive pricing ensures you get the best value for your money, with no hidden charges. Whether traveling solo or with a group, enjoy comfortable rides with trusted drivers and timely pickups."
    },
    {
        "name": "Pune to Lavasa Cab Fare",
        "description": "Find affordable cab fare options from Pune to Lavasa with various vehicle choices including sedans and SUVs. We offer clear fare structures for both one-way and round-trip journeys, ensuring budget-friendly travel without compromising on quality or safety."
    },
    {
        "name": "Pune Airport to Lavasa Taxi Fare",
        "description": "Convenient taxi services from Pune Airport to Lavasa with transparent fare details. Arrive hassle-free and begin your scenic trip with comfortable rides, experienced chauffeurs, and easy booking options. Ideal for travelers seeking airport transfers with peace of mind."
    },
    {
        "name": "Pune to Lavasa Cab Price",
        "description": "Affordable cab prices from Pune to Lavasa, designed to fit every budget. Our pricing is competitive and upfront, with no hidden fees. Choose from a range of vehicles to suit your travel needs, whether it’s a quick trip or an extended stay."
    },
    {
        "name": "Pune to Lavasa Taxi",
        "description": "Reliable taxi service from Pune to Lavasa offering timely pickups and professional drivers who prioritize your comfort and safety. Perfect for day trips, weekend getaways, or family outings, our taxis ensure a smooth and enjoyable travel experience."
    },
    {
        "name": "Pune to Lavasa Innova Fare",
        "description": "Book an Innova for your Pune to Lavasa trip at competitive fares. Spacious and comfortable, the Innova is ideal for families and groups looking for extra legroom and luggage space. Enjoy a smooth ride with experienced drivers and well-maintained vehicles."
    },
    {
        "name": "Pune to Lavasa Etios Cab Booking",
        "description": "Reserve an Etios cab from Pune to Lavasa for an economical and comfortable journey. Perfect for solo travelers or small groups, the Etios offers a fuel-efficient ride with air conditioning and reliable service, ensuring a pleasant trip."
    },
    {
        "name": "Pune to Lavasa Dzire Taxi",
        "description": "Book a Swift Dzire taxi for your Pune to Lavasa travel at affordable rates. Enjoy a comfortable sedan experience with spacious seating, smooth ride quality, and professional drivers who know the best routes to make your journey hassle-free."
    },
    {
        "name": "Pune to Lavasa Affordable Cab",
        "description": "Travel affordably from Pune to Lavasa with our range of budget-friendly cabs. We offer competitive prices without sacrificing quality or service, making your trip economical, safe, and comfortable, whether it’s a short visit or a longer stay."
    },
    {
        "name": "Pune to Lavasa Round Trip Cab",
        "description": "Plan your round trip from Pune to Lavasa with our dedicated cab service that offers flexible timing, comfortable vehicles, and courteous drivers. Perfect for weekend trips or business travel, enjoy peace of mind knowing your return journey is also arranged."
    },
    {
        "name": "Pune to Lavasa Family Cab",
        "description": "Travel comfortably with your family from Pune to Lavasa in spacious family cabs designed to accommodate everyone along with luggage. Our drivers are experienced and safety-conscious, ensuring a stress-free and enjoyable trip for all family members."
    }
],
"tableData": [
    ["Pune to Lavasa Taxi Fare", "Pune to Lavasa Cab Fare"],
    ["Pune Airport to Lavasa Taxi Fare", "Pune to Lavasa Cab Price"],
    ["Pune to Lavasa Taxi", "Pune to Lavasa Innova Fare"],
    ["Pune to Lavasa Etios Cab Booking", "Pune to Lavasa Dzire Taxi"],
    ["Pune to Lavasa Affordable Cab", "Pune to Lavasa Round Trip Cab"],
    ["Pune to Lavasa Family Cab", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Lavasa Cab Service",
        "WhyChoosedescription": "Prince Cabs offers a trustworthy and efficient cab service from Pune to Lavasa, perfect for leisure travelers, families, and corporate outings. Whether you're heading to explore Lavasa’s scenic hills, water sports, or peaceful retreats, we ensure a smooth, timely, and comfortable journey that sets the tone for a memorable visit."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for a Pleasant Ride",
        "WhyChoosedescription": "Our fleet consists of well-maintained, air-conditioned sedans and SUVs designed for comfort on the roughly 60 km route to Lavasa. With ample legroom, clean interiors, and luggage space, our vehicles offer a relaxing environment to enjoy the scenic drive through the Western Ghats."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our professional drivers are knowledgeable about the Pune to Lavasa route, traffic conditions, and scenic spots along the way. They ensure safe, courteous, and timely travel, while providing friendly assistance and local insights to enhance your journey experience."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Plans",
        "WhyChoosedescription": "Whether you need a one-way drop, a round trip, or a full-day rental to explore Lavasa and nearby attractions, Prince Cabs offers customizable packages tailored to your schedule. Booking is easy via phone, website, or WhatsApp with prompt confirmations and hassle-free cancellations."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "All vehicles are sanitized thoroughly before and after each trip, and undergo regular maintenance to ensure passenger safety and comfort. Equipped with safety essentials such as seat belts, GPS tracking, and first-aid kits, our cabs prioritize your well-being throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Options",
        "WhyChoosedescription": "We provide upfront, competitive pricing with no hidden charges. Prince Cabs accepts a variety of secure payment methods including UPI, credit/debit cards, net banking, and cash, making your booking and payment experience smooth and trustworthy."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Seamless Experience",
        "WhyChoosedescription": "Our customer support team is available around the clock to assist with bookings, inquiries, and any travel assistance you may require. We strive to make your Pune to Lavasa cab journey convenient, enjoyable, and stress-free from start to finish."
    }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Pune to Lavasa cab services?',
        answer: 'Yes, Prince Cabs provides comfortable and affordable cab services from Pune to Lavasa, ideal for leisure trips, weekend getaways, and nature escapes.',
    },
    {
        question: 'What types of vehicles are available for Pune to Lavasa travel?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to accommodate solo travelers, couples, and large groups.',
    },
    {
        question: 'Is the road from Pune to Lavasa safe for travel by cab?',
        answer: 'Yes, the route to Lavasa is scenic and safe. Our experienced drivers are well-versed with the hilly terrain to ensure a smooth and secure journey.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Lavasa?',
        answer: 'Absolutely! You can book both one-way and round-trip cabs. We also offer half-day and full-day packages depending on your travel plans.',
    },
    {
        question: 'What are the charges for a Pune to Lavasa cab?',
        answer: 'Fares vary depending on the vehicle type, trip duration, and any special requirements. Contact Prince Cabs for a customized and affordable quote.',
    },
    {
        question: 'How do I book a cab to Lavasa with Prince Cabs?',
        answer: 'Booking is simple—just call us or use our website to share your travel details, and we’ll help you select the right vehicle for your trip.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained?',
        answer: 'Yes, all our vehicles are regularly sanitized, cleaned, and maintained to ensure maximum safety and comfort for your Lavasa trip.',
    },
];

const testimonials = [
    {
        name: "Mr. Abhishek Kulkarni",
        position: "Weekend Traveler",
        text: "Booked a cab from Pune to Lavasa with Prince Cabs. The car was clean, the driver was courteous, and the scenic route made it a perfect day trip.",
        image: "/img/testimonial/testimonial-thumb-lavasa-1.png",
    },
    {
        name: "Ms. Snehal Desai",
        position: "Couple Traveler",
        text: "Our Lavasa getaway with Prince Cabs was seamless. The ride was comfortable and the cab arrived on time. Highly recommend their service!",
        image: "/img/testimonial/testimonial-thumb-lavasa-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lavasa Cab",
  "image": "https://princecab.com/assets/images/pune-lavasa-cab.jpg",
  "description": "Book Pune to Lavasa cab service with Prince Cabs for affordable, reliable, and comfortable taxi rides including Innova, Dzire, and Etios. Available for round trips and family travel. 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-lavasa-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Lavasa Cab | Reliable & Affordable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Lavasa cab service with Innova, Dzire, and Etios taxis. Affordable fares for round trips and family travel. Book your taxi online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Lavasa Taxi Fare, Pune to Lavasa Cab Fare, Pune Airport to Lavasa Taxi Fare, Pune to Lavasa Cab Price, Pune to Lavasa Taxi, Pune to Lavasa Innova Fare, Pune to Lavasa Etios Cab Booking, Pune to Lavasa Dzire Taxi, Pune to Lavasa Affordable Cab, Pune to Lavasa Round Trip Cab, Pune to Lavasa Family Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolavasacabs;